import script from "./ChamadaPublica.vue?vue&type=script&setup=true&lang=js"
export * from "./ChamadaPublica.vue?vue&type=script&setup=true&lang=js"

import "./ChamadaPublica.vue?vue&type=style&index=0&id=0ff2fcb2&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ff2fcb2"]])

export default __exports__